import { format } from 'date-fns'
import { formatAccountCurrency } from '@/lib/currency'

export type CsvColumn<T> = {
  label: string
  value: (row: T) => string | number | null | undefined
}

function csvCell(value: string | number | null | undefined) {
  const text = value == null ? '' : String(value)
  return `"${text.replace(/"/g, '""')}"`
}

export function exportCsv<T>(filename: string, rows: T[], columns: CsvColumn<T>[]) {
  const content = [
    columns.map((column) => csvCell(column.label)).join(';'),
    ...rows.map((row) => columns.map((column) => csvCell(column.value(row))).join(';')),
  ].join('\r\n')
  const blob = new Blob([`\uFEFF${content}`], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `${filename}-${format(new Date(), 'yyyy-MM-dd')}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}

export function formatCurrency(value: number) {
  return formatAccountCurrency(value)
}

export function formatPercent(value: number) {
  return `${value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`
}

export function formatDuration(seconds: number) {
  if (!seconds) return '0s'
  if (seconds < 60) return `${Math.round(seconds)}s`
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.round(seconds % 60)
  return [hours ? `${hours}h` : '', minutes ? `${minutes}min` : '', !hours && secs ? `${secs}s` : '']
    .filter(Boolean)
    .join(' ')
}
